import { Constants } from '@homegauge/shared';

export default {
  dateComponentData: { // data for Data Component
    preferredDate: '',
    alternateDate: '',
    preferredTimeRangeIndexes: [],
    alternateTimeRangeIndexes: [],
    preferredTimeRange: '',
    alternateTimeRange: '',
    time: '',
    end: '',
    fullName: '',
    inspectorId: '',
  },
  servicesComponentData: { // data for services step/component
    selectedServices: [],
    estimateError: null,
    estimateLoading: false,
    estimate: null,
  },
  locationComponentData: { // data for Location Component
    address1: '',
    address2: '',
    city: '',
    postalCode: '',
    state: '',
    country: Constants.Countries.unitedStates.abbreviation,
    additionalInstructions: '',
    isOccupied: true,
    latitude: 0,
    longitude: 0,
  },
  emailComponentData: {
    email: '',
    type: 'CUSTOMER',
  }, // data for users email
  contactComponentData: {
    contacts: [],
    role: 'BUYER',
  },
  reachedSummary: false,
  bookingLoading: false,
  bookingData: null,
  bookingErrors: {
    timeUnavailable: false,
    apiError: false,
  },
  appointmentCustomFields: [],
};
